import { DsLibLanguagesEnum } from './enums';
import { DsLibLanguageInterface } from './interfaces/ds-lib-language.interface';

export const ALLOWED_LANGUAGES: DsLibLanguageInterface[] = [
  { value: DsLibLanguagesEnum.FRENCH, text: 'Français' },
  { value: DsLibLanguagesEnum.ENGLISH, text: 'English' },
  { value: DsLibLanguagesEnum.SPANISH, text: 'Español' },
  { value: DsLibLanguagesEnum.CZECH, text: 'Čeština' },
  { value: DsLibLanguagesEnum.POLISH, text: 'Polski' },
];
